import { observer } from 'mobx-react'
import { useUserStore } from '../../../alive-academics/store/user.store'
import Unauthorized from '../../pages/Unauthorized'

// A reusable wrapper component
const ProtectedFeature = observer( ( { featureKey, children } ) => {
    const UserStore = useUserStore()

    const permission = UserStore.getUser?.features_permissions?.[featureKey] ?? false

    if ( !permission ) {
        return <Unauthorized />
    }

    return children
} )

export default ProtectedFeature